// Gestione automatica delle spese di immatricolazione e passaggio di proprietà
// basato sui tag dei prodotti nel carrello

document.addEventListener('DOMContentLoaded', function() {
  const FEES_CONFIG = {
    'NUOVO': {
      name: 'Spese immatricolazione e messa in strada',
      handle: 'spese-immatricolazione-e-messa-in-strada'
    },
    'USATO': {
      name: 'Passaggio di proprietà',
      handle: 'passaggio-di-proprieta'
    }
  };

  // Packages per i prodotti USATO
  const PACKAGE_PRODUCTS = [
    'pacchetto-base',
    'pacchetto-premium'
  ];

  let variantIds = {};
  let processingTimeout = null;
  let isModifying = false;
  let lastAutoModifyTime = 0;
  let pageLoadTime = Date.now();
  let hasProcessedThisLoad = false;

  /**
   * Recupera l'ID della variante e il prezzo di un prodotto
   */
  async function getVariantId(handle) {
    if (variantIds[handle]) {
      return variantIds[handle];
    }

    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) {
        return null;
      }

      const data = await response.json();
      
      if (data.variants && data.variants.length > 0) {
        const variant = data.variants[0];
        variantIds[handle] = {
          id: variant.id,
          price: variant.price
        };
        return variantIds[handle];
      }
    } catch (error) {
    }
    return null;
  }

  /**
   * Ricarica il DOM del carrello da AJAX
   */
  async function reloadCartDOM() {
    try {
      // Prova prima con la view ajax
      let response = await fetch('/cart?view=ajax', {
        method: 'GET'
      });
      
      // Se non funziona, prova senza view parameter
      if (!response.ok) {
        response = await fetch('/cart', {
          method: 'GET'
        });
      }

      if (!response.ok) {
        window.location.reload();
        return false;
      }

      const html = await response.text();
      
      // Parsa l'HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Trova il container con i prodotti
      const newProductsContainer = doc.querySelector('[data-products]');
      const currentProductsContainer = document.querySelector('[data-products]');
      
      if (newProductsContainer && currentProductsContainer) {
        currentProductsContainer.innerHTML = newProductsContainer.innerHTML;
        
        // Trigger un evento personalizzato dopo l'aggiornamento
        document.dispatchEvent(new CustomEvent('cart:dom-updated'));
        
        // Re-esegui processFees per verificare i nuovi elementi
        setTimeout(() => {
          processFees();
        }, 100);
        
        return true;
      } else {
        window.location.reload();
        return false;
      }
    } catch (error) {
      window.location.reload();
      return false;
    }
  }

  /**
   * Ottiene il carrello attuale
   */
  async function getCart() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) return null;
      const cartData = await response.json();
      return cartData;
    } catch (error) {
      return null;
    }
  }

  /**
   * Aggiunge un prodotto al carrello
   */
  async function addToCart(variantId, quantity = 1) {
    try {
      isModifying = true;
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: quantity
          }]
        })
      });

      if (!response.ok) {
        isModifying = false;
        return null;
      }
      
      const result = await response.json();
      isModifying = false;
      return result;
    } catch (error) {
      isModifying = false;
    }
    return null;
  }

  /**
   * Rimuove un prodotto dal carrello
   */
  async function removeFromCart(variantId) {
    try {
      isModifying = true;
      // Prima prova con il formato standard
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 0
        })
      });

      if (!response.ok) {
        // Se fallisce, prova con formato alternativo (tramite form)
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 0);
        
        const response2 = await fetch('/cart/change.js', {
          method: 'POST',
          body: formData
        });
        
        if (!response2.ok) {
          isModifying = false;
          return null;
        }
        
        const result = await response2.json();
        isModifying = false;
        return result;
      }

      const result = await response.json();
      isModifying = false;
      return result;
    } catch (error) {
      isModifying = false;
    }
    return null;
  }

  /**
   * Verifica e processa le spese necessarie
   */
  async function processFees() {
    // Debounce: se è già in attesa di esecuzione, cancella il timer e ne crea uno nuovo
    if (processingTimeout) {
      clearTimeout(processingTimeout);
    }
    processingTimeout = setTimeout(async function() {
      processingTimeout = null;
      await _processFees();
    }, 100);
  }

  async function _processFees() {
    // Evita l'esecuzione se è già in corso una modifica
    if (isModifying) {
      return;
    }
    
    // Nella prima 2 secondi dopo il caricamento della pagina,
    // esegui processFees solo una volta (evita 3 reload consecutivi)
    const now = Date.now();
    const timeSincePageLoad = now - pageLoadTime;
    if (timeSincePageLoad < 2000) {
      // Se è il primo caricamento, esegui una sola volta
      if (!hasProcessedThisLoad) {
        hasProcessedThisLoad = true;
        // Continua normalmente
      } else {
        // Nel primo timeout, non eseguire di nuovo
        return;
      }
    }
    
    // Blocca l'esecuzione per 3 secondi dopo un add/remove automatico
    // per evitare reload multipli quando ritorna nel carrello
    if (now - lastAutoModifyTime < 3000) {
      return;
    }
    
    // Se è appena avvenuto un reload automatico, blocca per 500ms
    // per evitare ulteriori reload infiniti
    const wasAutoReload = sessionStorage.getItem('autoReloadDone') === 'true';
    if (wasAutoReload) {
      sessionStorage.removeItem('autoReloadDone');
      // Resetta il flag di page load processing per permettere la verifica dopo reload
      hasProcessedThisLoad = false;
      // Resetta il lockout perché questo è un reload che abbiamo fatto noi
      lastAutoModifyTime = 0;
      // Blocca isModifying per 500ms per far stabilizzare il carrello
      isModifying = true;
      setTimeout(() => {
        isModifying = false;
      }, 500);
      return;
    }

    const cart = await getCart();
    if (!cart || !cart.items.length) {
      return;
    }
    
    // Conta i prodotti per tipo di spesa
    const feeQuantities = {
      'NUOVO': 0,
      'USATO': 0
    };
    
    // Costruisci una mappa dei variant IDs delle spese per riconoscerle
    const feeVariantIds = {};
    for (const [feeType, feeConfig] of Object.entries(FEES_CONFIG)) {
      const variantData = await getVariantId(feeConfig.handle);
      if (variantData) {
        feeVariantIds[variantData.id] = feeType;
      }
    }

    // Controlla i dati dei prodotti nel carrello
    for (const item of cart.items) {
      // Se è una spesa, skippa
      if (feeVariantIds[item.variant_id]) {
        continue;
      }
      
      // Prendi i dati dal DOM (dall'attributo data-product-tags)
      const cartItemElement = document.querySelector(`[data-key="${item.key}"]`);
      if (cartItemElement) {
        const tags = cartItemElement.getAttribute('data-product-tags') || '';
        
        if (tags.includes('NUOVO')) {
          feeQuantities['NUOVO'] += item.quantity;
        }
        if (tags.includes('USATO')) {
          feeQuantities['USATO'] += item.quantity;
        }
      } else {
        // Se l'elemento non è ancora nel DOM (e.g. dopo un reload),
        // prova a recuperare i tag dal product handle usando una fetch
        try {
          const response = await fetch(`/products/${item.handle}.js`);
          if (response.ok) {
            const product = await response.json();
            const tags = product.tags ? product.tags.join(',') : '';
            
            if (tags.includes('NUOVO')) {
              feeQuantities['NUOVO'] += item.quantity;
            }
            if (tags.includes('USATO')) {
              feeQuantities['USATO'] += item.quantity;
            }
          }
        } catch (error) {
          // Se fallisce, non contare questo prodotto
        }
      }
    }

    // Raccogli tutte le operazioni da fare
    let hasChanges = false;
    
    // Se nessuna spesa è richiesta, rimuovi eventuali spese dal carrello
    if (feeQuantities['NUOVO'] === 0 && feeQuantities['USATO'] === 0) {
      for (const [feeType, feeConfig] of Object.entries(FEES_CONFIG)) {
        const variantData = variantIds[feeConfig.handle];
        if (variantData) {
          const feeExists = cart.items.some(item => item.variant_id === variantData.id);
          if (feeExists) {
            await removeFromCart(variantData.id);
            hasChanges = true;
          }
        }
      }

      // Se non ci sono più USATO, rimuovi anche tutti i package
      for (const packageHandle of PACKAGE_PRODUCTS) {
        const packageVariantData = await getVariantId(packageHandle);
        if (packageVariantData) {
          const packageExists = cart.items.some(item => item.variant_id === packageVariantData.id);
          if (packageExists) {
            await removeFromCart(packageVariantData.id);
            hasChanges = true;
          }
        }
      }
    } else {
      // Processa le spese necessarie
      for (const feeType of Object.keys(FEES_CONFIG)) {
        const feeConfig = FEES_CONFIG[feeType];
        if (!feeConfig) continue;
        
        const requiredQuantity = feeQuantities[feeType];
        const variantData = await getVariantId(feeConfig.handle);
        if (!variantData) {
          continue;
        }

        // Trova la spesa nel carrello se esiste
        const feeItem = cart.items.find(item => item.variant_id === variantData.id);
        
        if (requiredQuantity > 0) {
          if (!feeItem) {
            // Aggiungi la spesa con la quantità corretta
            await addToCart(variantData.id, requiredQuantity);
            hasChanges = true;
          } else if (feeItem.quantity !== requiredQuantity) {
            // Aggiorna la quantità se diversa
            await removeFromCart(variantData.id);
            hasChanges = true;
          }
        } else {
          // Rimuovi la spesa se non serve
          if (feeItem) {
            await removeFromCart(variantData.id);
            hasChanges = true;
          }
        }
      }

      // Se non ci sono più USATO, rimuovi anche tutti i package
      if (feeQuantities['USATO'] === 0) {
        for (const packageHandle of PACKAGE_PRODUCTS) {
          const packageVariantData = await getVariantId(packageHandle);
          if (packageVariantData) {
            const packageExists = cart.items.some(item => item.variant_id === packageVariantData.id);
            if (packageExists) {
              await removeFromCart(packageVariantData.id);
              hasChanges = true;
            }
          }
        }
      }
    }
    
    // Se c'è stato almeno un cambiamento, ricarica la pagina una volta
    if (hasChanges) {
      lastAutoModifyTime = Date.now();
      isModifying = true;
      sessionStorage.setItem('autoReloadDone', 'true');
      window.location.reload();
    }
  }

  // Esegui al caricamento della pagina
  setTimeout(processFees, 150);

  // Monitora i cambiamenti del carrello
  document.addEventListener('cart:updated', function() {
    processFees();
  });

  // Monitora i cambiamenti di quantità nel carrello
  document.addEventListener('quantityChanged', function() {
    processFees();
  });

  // Monitora le modifiche DOM nel carrello (rimozione/aggiunta prodotti)
  const productsContainer = document.querySelector('[data-products]');
  if (productsContainer) {
    const mutationObserver = new MutationObserver(function(mutations) {
      processFees();
    });

    mutationObserver.observe(productsContainer, {
      childList: true,       // Monitora aggiunta/rimozione figli
      subtree: true,         // Monitora anche elementi annidati
      attributes: true,      // Monitora cambiamenti attributi
      characterData: false   // Non monitora testo
    });
  }

  // Monitora anche i click sui pulsanti di rimozione
  document.addEventListener('click', function(e) {
    // Rileva click su pulsanti di quantità o rimozione
    if (e.target.closest('[data-id]') || e.target.closest('.js-qty__adjust')) {
      processFees();
    }
  });
});
